import { createContext, useCallback, useContext } from 'react';
import CONFIG from './CONFIG';
import useApiService from './ApiService';

const FragmentApiContext = createContext(null);

export function FragmentApiProvider({ children }) {
  const { get, post, put, del } = useApiService(CONFIG.SERVER_CHANNEL);

  const getFragments = useCallback(
    async (skip, limit) => {
      if (!skip) skip = 0;
      if (!limit) limit = 10;

      try {
        const response = await get(`/v1/fragments?skip=${skip}&limit=${limit}`);
        return response.data;
      } catch (error) {
        console.error('Error fetching fragments:', error);
        throw error;
      }
    },
    [get],
  );

  const getFragmentById = useCallback(
    async (fragmentId) => {
      try {
        const response = await get(`/v1/fragments/${fragmentId}`);
        return response.data;
      } catch (error) {
        console.error('Error fetching fragment by ID:', error);
        throw error;
      }
    },
    [get],
  );

  const createFragment = useCallback(
    async (fragmentData) => {
      try {
        const response = await post(`/v1/fragments`, fragmentData);
        return response.data;
      } catch (error) {
        console.error('Error creating fragment:', error);
        throw error;
      }
    },
    [post],
  );

  const updateFragment = useCallback(
    async (fragmentId, fragmentData) => {
      try {
        const response = await put(`/v1/fragments/${fragmentId}`, fragmentData);
        return response.data;
      } catch (error) {
        console.error('Error updating fragment:', error);
        throw error;
      }
    },
    [put],
  );

  const deleteFragment = useCallback(
    async (fragmentId) => {
      try {
        const response = await del(`/v1/fragments/${fragmentId}`);
        return response.data;
      } catch (error) {
        console.error('Error deleting fragment:', error);
        throw error;
      }
    },
    [del],
  );

  return (
    <FragmentApiContext.Provider
      value={{
        getFragments,
        getFragmentById,
        createFragment,
        updateFragment,
        deleteFragment,
      }}
    >
      {children}
    </FragmentApiContext.Provider>
  );
}

export function useFragmentApi() {
  const context = useContext(FragmentApiContext);
  if (!context) {
    throw new Error('useFragmentApi must be used within a FragmentApiProvider');
  }
  return context;
}
